import { useEffect } from 'react';
import { useAuthenticateUser } from '@/hooks/api/auth';
import { APP_ROUTE } from '@/constants';
import { toast } from '@/hooks/use-toast';
import Loader from '@/components/loader';
import { useNavigate } from 'react-router-dom';
import { Cookies } from 'react-cookie';
import { Toaster } from '@/components/ui/toaster';
import { useTranslation } from 'react-i18next';
import { useClient } from '@/states/common';

const NewVerifyEmailView: React.FC = () => {
  const authenticateUser = useAuthenticateUser();
  const navigate = useNavigate();
  const client = useClient();
  const { t } = useTranslation('signup');

  const verifyUserToken = async (token: string | null) => {
    try {
      if (!token) {
        throw new Error(t('verify-email.token-missing', 'Token is Missing'));
      }
      const res = await authenticateUser({ token, strategy: 'verify' });
      if (res.isVerified) {
        toast({
          variant: 'success',
          title: t(
            'verify-email.success-title',
            'Email verification Successful.'
          ),
          description: t(
            'verify-email.success-message',
            'Your email has been verified successfully.'
          ),
          duration: 10000,
        });
        navigate(`/ws/${client.id}/${APP_ROUTE.HOME}`);
      }
    } catch (error: any) {
      if (/invalid/gi.test(error.message)) {
        toast({
          variant: 'destructive',
          title: t(
            'verify-email.error-invalid',
            'Invalid authentication data.'
          ),
          description: t('verify-email.error-try-again', 'Please try again.'),
        });
      }
      const accessToken = new Cookies().get('accessToken');
      if (!accessToken) {
        toast({
          variant: 'destructive',
          title: error.message,
          description: t('verify-email.error-try-again', 'Please try again.'),
        });
      }
      navigate(`/${APP_ROUTE.AUTH}/${APP_ROUTE.LOGIN}`);
    }
  };
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    verifyUserToken(params.get('token'));
  }, []);
  return (
    <>
      <Loader show />
      <Toaster />
    </>
  );
};

export default NewVerifyEmailView;
